module.exports = __webpack_public_path__ + "img/2_230.8d7ce9be.png";